import styled from "styled-components";
import { themevals as theme } from "theme/themevals";
import { bp } from "theme/themevals";

interface CustomProps {
  $active?: boolean;
  $submitting?: boolean;
  $customStyles?: {[key: string]: string};
  $isFixed?: boolean;
  $noFirstColumnMinWidth?: boolean;
  size?: any
}

export const TableTop = styled.div<CustomProps>`  
  margin-bottom: 5px;
  width: 100%;  
`

export const TableBottom = styled.div<CustomProps>`
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  margin-top: 20px;
  width: 100%;
`

export const TableWrapper = styled.div<CustomProps>`
  width: 100%;  
  background-color: ${theme?.colors?.white};
  border-radius: 6px;
  overflow: auto;
  ${(props) => props.$customStyles}

  /* Scroll shadow indicators — visible only when there's overflow to scroll */
  background:
    linear-gradient(to right, white 30%, rgba(255,255,255,0)) left center / 40px 100% no-repeat local,
    linear-gradient(to left, white 30%, rgba(255,255,255,0)) right center / 40px 100% no-repeat local,
    linear-gradient(to right, rgba(0,0,0,0.06), rgba(0,0,0,0)) left center / 14px 100% no-repeat scroll,
    linear-gradient(to left, rgba(0,0,0,0.06), rgba(0,0,0,0)) right center / 14px 100% no-repeat scroll;
`;

export const Table = styled.table<CustomProps>`
  width: 100%;  
  ${(props) => props.$isFixed ? `table-layout: fixed;`:``}
  ${(props: any) => props.size === "sm" ? `
    font-size: .875rem;
    thead th,
    tfoot th { padding: 6px 10px!important; }
    tbody td{    
      padding: 6px 10px!important;    
      & > div {margin: -6px -10px!important; padding: 6px 10px!important;}
      & > a {margin: -6px -10px!important; padding: 6px 10px!important;}
    }
  `:``}
`;

export const TableHeader = styled.thead`
  width: 100%;
  tr{
    border-radius:6px;border-bottom: 1px solid #EBEBEB;}
  th{
    padding:14px 20px;
    font-weight:500;
    font-size:12px;
    font-family:"Poppins";
    color:${theme?.colors?.dkgrey};
    background:#F8F8F8;
    border:none;
    cursor:pointer;
    & div span {
      width: 100%;
    }
         &:first-child{
        border-radius: 6px 0 0 6px;}
  }
  th:last-child{
    border-radius: 0 6px 6px 0; 
  }
`;

export const TableFooter = styled.tfoot`
  width: 100%;
  th{
    padding:14px 30px;
    font-weight:600;
    font-size:14px;
    color:${theme?.colors?.base_700};
    cursor:pointer;
    & div span {
      width: 100%;
    }
   
  tr {
    
  }

`;

export const TableBody = styled.tbody<CustomProps>`
  width: 100%;
  td{
    
    padding:14px 20px;
    font-family:"Poppins";
    font-size:14px;
    cursor:default;
    color:${theme?.colors?.dkgrey};
    & > div {margin: -14px -20px; padding:14px 20px;}
    & > a {display: block; margin: -14px -20px; padding:14px 20px; text-decoration: none; color: ${theme?.colors?.base_700};}
    & > a:hover {color: ${theme?.colors?.base_700}; }
  }
  tr{
    border-bottom: 1px solid #EBEBEB;
    cursor:pointer;
    &:hover{
        
    }
  }
  tr:first-child{
   
  }  
  tr:last-child {
    border-bottom: none;
  }

  ${(props) => !props.$noFirstColumnMinWidth ? `
    tr td:first-child {
      min-width: 275px;
    }
    @media (max-width: ${bp.lg}) {
      tr td:first-child {
        min-width: 0;
      }
    }
  ` : ``}
`;

export const CellInner = styled.div`
  display: flex;
  gap: 0px;
  align-items:flex-start;
  text-align:left;
`;

export const TableActions = styled.div`
  display:flex;
  align-items: center;
  justify-content: space-between!important;  
  flex-wrap: wrap;    
  flex: 0 1 auto; 
  gap: 15px 30px; 
  margin-bottom: 15px;
  & form { display: block; flex-grow: 1 }
`;

export const TableFilters = styled.div<CustomProps>`
  display: ${props => props.$active ? "block" : "none"};
  position: relative;
  ${props => props.$customStyles};
`;

export const FiltersWrap = styled.div<CustomProps>`
  position: absolute;
  z-index: 1042;
  width: 100%;
  max-width: 300px;
  right: 0;
  top: 0;
  padding: 5px;
  background: #fff;
  flex-grow: 1;
  display: flex; 
  flex-direction: column;   
  align-items: flex-end;
  gap: 15px;  
  border-radius: 5px;
  border: 1px solid ${theme?.colors?.base_300};  
  box-shadow: 0px 0px 5px ${theme?.colors?.base_300};
`;

export const TableBtns = styled.div`
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  & button { 
    min-height: 36px;
  }
`;

export const TablePagination = styled.div`
  display:flex;
  flex-wrap: wrap;
  align-items: center;
  color: ${theme?.colors?.base_700}!important;
  gap: 10px 20px;
  font-size: .875rem;
  & .page-count{
    display: flex;
    align-items: center;
  }
  & button {
    cursor: pointer;
    width: 36px;
    text-align: center;
    border-radius: 4px;
    padding: 3px!important;
    border-color: ${theme?.colors?.mdgrey}!important;
    background-color: ${theme?.colors?.white};
    & svg {height: 10px; width: auto;}
    &.btn-next svg ,&.btn-last svg {transform: scaleX(-1);}
  }
  & .react-select__control {
    min-height: auto;
    max-height:34px;
    margin: 0 .25rem;
    font-family:Poppins;
    & .react-select__indicator {padding: 1px 8px!important;}
    & .react-select__indicator svg {height: 10px!important; width: auto!important;}
    & .react-select__indicator-separator {display: none;}
  }  
`;

export const TableSearch = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 4px 12px 0px rgba(113, 125, 150, 0.05);
`;